import React from "react";
import { format } from "date-fns";
import { parseISOWithoutTime } from "helpers/date-helpers";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { membershipStatePropType } from "components/propTypes";
import { analytics, dateFnsFormats } from "rtr-constants";
import { displayModal } from "actions/shared-actions";
import AddShipmentModal from "components/source/membership/modals/AddShipmentModal/AddShipmentModalWrapper";
import ActionLogger from "action-logger";

class MembershipAddSwapCTA extends React.Component {
  static propTypes = {
    displayAddShipmentModal: PropTypes.func.isRequired,
    membershipState: membershipStatePropType.isRequired,
  };

  clickAddShipmentCTA = () => {
    const { id, membershipId, monthlyShipmentLimit, membershipTierRevisionId } = this.props.membershipState;

    ActionLogger.logAction({
      object_type: analytics.OBJECT_TYPE.PDP,
      action: analytics.ACTION_TYPE.CLICK_ADD_SHIPMENT,
      user_id: id,
      membership_id: membershipId,
      monthly_shipment_limit: monthlyShipmentLimit,
      membership_tier_revision_id: membershipTierRevisionId,
    });

    this.props.displayAddShipmentModal();
  };

  render() {
    const { membershipState: { futureMembershipTierRevision = {}, monthlyShipmentLimit, nextBillingDate } = {} } =
      this.props;

    const nextTermShipmentLimit = futureMembershipTierRevision.monthlyShipmentLimit || monthlyShipmentLimit;
    const pluralShipments = nextTermShipmentLimit > 1;
    const nextBillingDateFormatted = format(parseISOWithoutTime(nextBillingDate), dateFnsFormats.day);

    return (
      <div className="membership-add-swap-cta">
        Your next{pluralShipments ? " " + nextTermShipmentLimit : ""} shipment{pluralShipments ? "s" : ""} unlock
        {pluralShipments ? "" : "s"} {nextBillingDateFormatted + ". "}
        <button type="button" className="universal-underline" onClick={this.clickAddShipmentCTA}>
          Add a Shipment
        </button>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    displayAddShipmentModal: () => {
      dispatch(displayModal(AddShipmentModal.modalName));
    },
  };
};

export default connect(null, mapDispatchToProps)(MembershipAddSwapCTA);
export { MembershipAddSwapCTA as UnconnectedMembershipAddSwapCTA };
